
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
window.M = require('materialize-css/dist/js/materialize');
window.Chart = require('./Chart.min.js');
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//require('./bootstrap');
//require('./bootstrap');
//require('./bootstrap');

// pptx generator
window.pptx = require("pptxgenjs");

window.Vue = require('vue');
window.Popper = require('popper.js').default;
window.Moment = require('moment');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found');
}


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Scores
Vue.component('stress-score', require('./components/scores/StressScoreForm.vue'));
Vue.component('stress-score-summary', require('./components/scores/PastMonthsSummary.vue'));
Vue.component('this-month-score-summary', require('./components/scores/partials/ThisMonthScore.vue'));
Vue.component('pending-stress-score-component', require('./components/scores/admin/PendingStressScoreComponent.vue'));

// Diaries
Vue.component('diary-form', require('./components/diaries/DiaryForm.vue'));
Vue.component('diary-show', require('./components/diaries/DiaryShow.vue'));
Vue.component('task-summary', require('./components/diaries/tasks/TaskSummary.vue'));

// Issues
Vue.component('issue-form', require('./components/issues/IssueQuestionAnswerForm.vue'));
Vue.component('outstanding-issue-component', require('./components/issues/partials/OutstandingIssueComponent.vue'));

// Dashboard components
Vue.component('dashboard-component', require('./components/dashboard/DashboardComponent.vue'));

const app = new Vue({
    el: '#app'
});





// WEBPACK FOOTER //
// ./resources/assets/js/app.js